import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { ReminderItem } from './ReminderItem';
import { reminder } from '../../../model/reminder';

interface IProps extends StyledComponentProps {
    doneReminder: (reminder: reminder, done: boolean) => void;
    onReminderClick: (id: string) => void;
    reminderList: Array<reminder>;
    selected: string;
    showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}

export const ReminderList = (props: IProps) => {
    const classes = props.classes;
    
    return (<List className={classes?.root}>
        {console.log("props.reminderList", props.reminderList)}
        {props.reminderList && props.reminderList.length > 0 && props.reminderList.map(r =>
            <ReminderItem
                classes={classes}
                isSelected={props.selected === r._id}
                reminder={r}
                key={r._id}
                doneReminder={props.doneReminder}
                onReminderClick={props.onReminderClick}
                showContactInfo={props.showContactInfo}
                // navigateTo={props.navigateTo}
            />)}
    </List>)
};